



























































































































































import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    "generated-reports-provider": () =>
      import("@/components/app/admin/insights/generatedReportsProvider.vue")
  }
})
export default class GeneratedReportsListing extends Vue {
  // Computed

  @Prop({ required: true })
  public code!: string;

  @Prop({ default: () => ({}) })
  public manualFilters!: Record<string, any>;

  @Prop({ required: true })
  public helpParams!: string;
}
